export default [
  {
    description: 'Chat do Estudante com o Professor',
    path: '/ferramentas/chat_estudante_professor',
    name: 'chat_estudante_professor', //SAEWEB NEW
    component: () => import('@/views/ferramentas/chat_estudante_professor/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Chat do Estudante com o Professor',
    path: '/ferramentas/chat_estudante_professor',
    name: 'chat2_estudante_professor',
    component: () => import('@/views/ferramentas/chat_estudante_professor/Index.vue'),
    meta: {
      isLegacy: true, //remover quando não for utilizar pelo SAEWEB antigo. Daí, vai aplicar o template por padrão
      permissions: [

      ],
    },
    goesToMenu: true,
  },
]

